import { HabilitationService } from 'src/app/modules/shared/services/habilitation.service';

export class HomeHabilitation extends HabilitationService {
	getFunction(): string {
		throw new Error('Method not implemented.');
	}

}
